<template>
  <div>
    <Carousel />
    <div class="content">
      <h1 class="main-title">{{ $t('home.title') }}</h1>
      <p class="main-subtitle">{{ $t('home.subtitle') }}</p>
      <img
        src="../assets/img/tuanduijieshao.png"
        alt="团队介绍"
        class="section-image"
      />

      <div class="modules-grid">
        <div class="module-card" @click="goToPage('/intro')">
          <div class="card-icon">
            <img src="../assets/img/1.jpg" alt="项目介绍" />
          </div>
          <h3 class="card-title">{{ $t('home.intro.title') }}</h3>
          <p class="card-desc">{{ $t('home.intro.desc') }}</p>
        </div>

        <div class="module-card" @click="goToPage('/market')">
          <div class="card-icon">
            <img src="../assets/img/2.jpg" alt="市场机遇" />
          </div>
          <h3 class="card-title">{{ $t('home.market.title') }}</h3>
          <p class="card-desc">{{ $t('home.market.desc') }}</p>
        </div>

        <div class="module-card" @click="goToPage('/tech')">
          <div class="card-icon">
            <img src="../assets/img/3.jpg" alt="技术架构" />
          </div>
          <h3 class="card-title">{{ $t('home.tech.title') }}</h3>
          <p class="card-desc">{{ $t('home.tech.desc') }}</p>
        </div>

        <div class="module-card" @click="goToPage('/token')">
          <div class="card-icon">
            <img src="../assets/img/4.jpg" alt="通证经济" />
          </div>
          <h3 class="card-title">{{ $t('home.token.title') }}</h3>
          <p class="card-desc">{{ $t('home.token.desc') }}</p>
        </div>

        <div class="module-card" @click="goToPage('/ecosystem')">
          <div class="card-icon">
            <img src="../assets/img/5.jpg" alt="生态应用" />
          </div>
          <h3 class="card-title">{{ $t('home.ecosystem.title') }}</h3>
          <p class="card-desc">{{ $t('home.ecosystem.desc') }}</p>
        </div>

        <!-- <div class="module-card" @click="goToPage('/static')">
          <div class="card-icon">
            <img src="../assets/img/6.jpg" alt="静态收益" />
          </div>
          <h3 class="card-title">{{ $t('home.static.title') }}</h3>
          <p class="card-desc">{{ $t('home.static.desc') }}</p>
        </div> -->

        <div class="module-card" @click="goToPage('/dynamic')">
          <div class="card-icon">
            <img src="../assets/img/7.jpg" alt="推广模型" />
          </div>
          <h3 class="card-title">{{ $t('home.dynamic.title') }}</h3>
          <p class="card-desc">{{ $t('home.dynamic.desc') }}</p>
        </div>

        <div class="module-card" @click="goToPage('/roadmap')">
          <div class="card-icon">
            <img src="../assets/img/8.jpg" alt="发展路线图" />
          </div>
          <h3 class="card-title">{{ $t('home.roadmap.title') }}</h3>
          <p class="card-desc">{{ $t('home.roadmap.desc') }}</p>
        </div>

        <div class="module-card" @click="showComingSoon">
          <div class="card-icon">
            <img src="../assets/img/6.jpg" alt="AI量化" />
          </div>
          <h3 class="card-title">{{ $t('home.aiQuant.title') }}</h3>
          <p class="card-desc">{{ $t('home.aiQuant.desc') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Carousel from '../components/Carousel.vue';
export default {
  components: {
    Carousel,
  },
  name: 'Home',
  mounted() {
    // 监听语言切换事件
    this.$root.$on('language-changed', () => {
      this.$forceUpdate();
    });
  },
  beforeDestroy() {
    this.$root.$off('language-changed');
  },
  methods: {
    goToPage(path) {
      this.$router.push(path);
    },
    showComingSoon() {
      this.$message({
        message: this.$t('common.comingSoon'),
        type: 'info',
        duration: 2000,
      });
    },
  },
};
</script>

<style scoped>
.content {
  width: 100%;
  max-width: 100%;
  margin: 0;
  padding: 30px 15px;
  min-height: calc(100vh - 600px);
}

.main-title {
  font-size: 48px;
  line-height: 64px;
  font-weight: 700;
  color: var(--text-primary);
  text-align: center;
  margin-bottom: 20px;
}

.main-subtitle {
  font-size: 20px;
  line-height: 32px;
  color: var(--text-secondary);
  text-align: center;
  margin-bottom: 40px;
  max-width: 900px;
  margin-left: auto;
  margin-right: auto;
}

.section-image {
  width: 100%;
  max-width: 100%;
  display: block;
  margin: 0 auto 40px;
}

.modules-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 30px;
  margin-top: 60px;
}

.module-card {
  background: var(--bg-card);
  border-radius: 12px;
  padding: 30px 20px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: var(--shadow-sm);
  border: 2px solid var(--border-color);
}

.module-card:hover {
  transform: translateY(-10px);
  box-shadow: var(--shadow-lg);
  border-color: var(--accent-primary);
  background: var(--bg-card-hover);
}

.card-icon {
  width: 120px;
  height: 120px;
  margin: 0 auto 20px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: var(--shadow-md);
}

.card-icon img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.card-title {
  font-size: 22px;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 12px;
}

.card-desc {
  font-size: 14px;
  color: var(--text-secondary);
  line-height: 22px;
  margin: 0;
}

@media (max-width: 1200px) {
  .modules-grid {
    grid-template-columns: repeat(3, 1fr);
    gap: 25px;
  }
}

@media (max-width: 768px) {
  .main-title {
    font-size: 32px;
    line-height: 44px;
  }

  .main-subtitle {
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 30px;
  }

  .section-image {
    margin-bottom: 20px;
  }

  .modules-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    margin-top: 40px;
  }

  .module-card {
    padding: 20px 15px;
  }

  .card-icon {
    width: 100px;
    height: 100px;
    margin-bottom: 15px;
  }

  .card-title {
    font-size: 18px;
  }

  .card-desc {
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .modules-grid {
    grid-template-columns: 1fr;
  }
}
</style>
